const CustomSearch = () => {
    (function () {
        function ready(fn) {
            if (document.readyState !== 'loading') {
                fn();
                return;
            }
            document.addEventListener('DOMContentLoaded', fn);
        }

        ready(function () {
            var forms = document.querySelectorAll('form.search-form');

            for (var i = 0; i < forms.length; i++) {
                (function (form) {
                    form.addEventListener('submit', function (e) {
                        var input = form.querySelector('input[name="s"]');
                        if (!input) {
                            return;
                        }

                        var term = (input.value || '').trim();
                        if (!term) {
                            return;
                        }

                        e.preventDefault();

                        // Encode and turn spaces into + (WP friendly)
                        var encoded = encodeURIComponent(term).replace(/%20/g, '+');
                        window.location.href = '/search/' + encoded;
                    });
                })(forms[i]);
            }
        });
    })();
};

export default CustomSearch;
